(() => {
  if (customElements.get('cards-slider')) {
    return;
  }

  class CardsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.header = document.querySelector('.shopify-section.header-wrapper');
    }

    connectedCallback() {
      this.initSlider();
      this.setupSmoothScrolling();
      this.setSliderPosition();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        spaceBetween: 4,
        slidesPerView: 'auto',
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    setupSmoothScrolling() {
      this.querySelectorAll('.card-slide a').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const targetId = link.getAttribute('href');
          const targetSection = document.querySelector(targetId);
          if (targetSection) {
            const targetOffset =
              targetSection.offsetTop - this.getSliderTopOffset();
            const initialTop = window.pageYOffset;
            const distance = targetOffset - initialTop;
            const duration = 1500; // Adjust the duration
            let startTime = null;

            function scrollToTarget(currentTime) {
              if (startTime === null) startTime = currentTime;
              const timeElapsed = currentTime - startTime;
              const easing = function (t) {
                return t < 0.5
                  ? 4 * t * t * t
                  : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
              };
              const run = easing(Math.min(1, timeElapsed / duration));
              window.scrollTo(0, initialTop + distance * run);
              if (timeElapsed < duration) {
                requestAnimationFrame(scrollToTarget);
              }
            }

            requestAnimationFrame(scrollToTarget);
            history.pushState(null, null, targetId);
          }
        });
      });

      window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
        const sections = document.querySelectorAll('[id^="target-section--"]');

        sections.forEach((section) => {
          const sectionId = '#' + section.id;
          const allSlides = document.querySelectorAll(
            '.cards-slider .swiper-slide a',
          );
          const sectionInView = section.offsetTop - section.offsetHeight;
          const sectionOutView = section.offsetTop + section.offsetHeight;
          const targetSlideIndex = Array.from(
            this.querySelectorAll('.swiper-slide'),
          ).findIndex(
            (slide) =>
              slide.querySelector('a').getAttribute('href') === sectionId,
          );

          if (currentScroll >= sectionInView) {
            if (!document.querySelector('.inView')) {
              section.classList.add('inView');
              const activeCards = document.querySelectorAll(
                `.cards-slider a[href="${sectionId}"]`,
              );

              allSlides.forEach((link) => {
                link.classList.remove('active');
              });

              activeCards.forEach((activeCard) => {
                activeCard.classList.add('active');
              });

              this.slider.slideTo(targetSlideIndex, 300, false);
            }
          } else {
            section.classList.remove('inView');
          }

          if (currentScroll >= sectionOutView) {
            section.classList.remove('inView');
          }
        });
      });
    }

    getSliderTopOffset() {
      return this.offsetHeight + this.getHeaderElementHeight();
    }

    setSliderPosition() {
      const section = this.closest('.cards-slider-nav');
      const sticky = section.offsetTop;

      window.addEventListener('scroll', () => {
        if (this.classList.contains('cards-slider--sticky')) {
          this.style.top = `${this.getHeaderElementHeight()}px`;
        }

        this.stickyFunction(section);
      });
    }

    stickyFunction(section) {
      if (
        window.pageYOffset + this.getHeaderElementHeight() >=
        section.offsetTop
      ) {
        section.classList.add('sticky');
      } else {
        section.classList.remove('sticky');
      }
    }

    getHeaderElementHeight() {
      const headerBody = this.header.querySelector('.header__body');
      const headerBar = this.header.querySelector('.header__bar');

      let headerElement = headerBar;

      if (window.innerWidth < 1220) {
        headerElement = headerBody;
      }

      return headerElement.offsetHeight;
    }
  }

  customElements.define('cards-slider', CardsSlider);
})();
